import { FC } from 'react'
import './split-recommendation-card.css'

// COMPONENTS
import * as Icons from '@icons'
import Card from '@components/atoms/card'

// UTILITIES
import { priceFormatter } from '@utils/number-helper'
import { flatten } from '@utils/string-helper'

interface Props {
    className?: string
    peopleSplittingCount: number
    recommendedContribution: number
    onIncreasePeopleCount: () => void
    onDecreasePeopleCount: () => void
    onApplyRecommendedAmount: () => void
}

const SplitRecommendationCard: FC<Props> = (props) => {
    const {
        className,
        peopleSplittingCount,
        recommendedContribution,
        onIncreasePeopleCount,
        onDecreasePeopleCount,
        onApplyRecommendedAmount,
    } = props
    const decreaseDisabled = peopleSplittingCount <= 2

    return (
        <Card light className={flatten('split-recommendation-card', className)}>
            <div className='split-recommendation-count-row'>
                <p className='text-body'><strong>How many people are splitting?</strong></p>
                <div className='split-recommendation-count-controls'>
                    <button
                        type="button"
                        className='split-recommendation-count-button'
                        aria-label="Decrease people splitting count"
                        onClick={onDecreasePeopleCount}
                        disabled={decreaseDisabled}
                    >
                        <span className='split-recommendation-minus-glyph' aria-hidden />
                    </button>
                    <h3>{peopleSplittingCount}</h3>
                    <button type="button" className='split-recommendation-count-button' aria-label="Increase people splitting count" onClick={onIncreasePeopleCount}>
                        <Icons.Plus tint="currentColor" width="1rem" height="1rem" />
                    </button>
                </div>
            </div>
            <div className='split-recommendation-row'>
                <p className='split-recommendation-copy text-body'>
                    <span className='split-recommendation-label'>Suggested Amount:</span>
                    <strong>{priceFormatter.format(recommendedContribution / 100)}</strong>
                </p>
                <button
                    type="button"
                    className='split-recommendation-apply-button'
                    onClick={onApplyRecommendedAmount}
                    disabled={recommendedContribution <= 0}
                >
                    Update Your Pledge
                </button>
            </div>
        </Card>
    )
}

export default SplitRecommendationCard
